import React from "react";

export function ChatCenteredText() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9122 12.9049H19.8537"
        stroke="#6A3BFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9122 16.8757H19.8537"
        stroke="#6A3BFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5757 24.3085L16.7392 27.3734C16.6493 27.5197 16.5234 27.6405 16.3735 27.7243C16.2236 27.8081 16.0547 27.8521 15.883 27.8521C15.7113 27.8521 15.5424 27.8081 15.3926 27.7243C15.2427 27.6405 15.1168 27.5197 15.0268 27.3734L13.1904 24.3085C13.104 24.1614 12.9807 24.0394 12.8327 23.9545C12.6847 23.8696 12.5172 23.8248 12.3466 23.8246H4.96345C4.70017 23.8246 4.44768 23.72 4.26152 23.5338C4.07535 23.3476 3.97076 23.0951 3.97076 22.8319V6.94886C3.97076 6.68559 4.07535 6.43309 4.26152 6.24693C4.44768 6.06076 4.70017 5.95618 4.96345 5.95618H26.8026C27.0659 5.95618 27.3184 6.06076 27.5045 6.24693C27.6907 6.43309 27.7953 6.68559 27.7953 6.94886V22.8319C27.7953 23.0951 27.6907 23.3476 27.5045 23.5338C27.3184 23.72 27.0659 23.8246 26.8026 23.8246H19.4195C19.2489 23.8248 19.0813 23.8696 18.9333 23.9545C18.7853 24.0394 18.6621 24.1614 18.5757 24.3085V24.3085Z"
        stroke="#6A3BFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
